import { useTranslation } from 'react-i18next';
import { Link } from 'wouter';
import {
  Briefcase,
  Calendar,
  Users,
  Building2,
  Settings,
  type LucideIcon,
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface QuickAction {
  labelKey: string;
  icon: LucideIcon;
  path: string;
}

const ACTIONS: QuickAction[] = [
  { labelKey: 'quickActions.services', icon: Briefcase, path: '/admin/services' },
  { labelKey: 'quickActions.availability', icon: Calendar, path: '/admin/availability' },
  { labelKey: 'quickActions.bookings', icon: Users, path: '/admin/bookings' },
  { labelKey: 'quickActions.team', icon: Building2, path: '/admin/team' },
  { labelKey: 'quickActions.settings', icon: Settings, path: '/admin/settings' },
];

interface QuickActionsBarProps {
  className?: string;
}

export function QuickActionsBar({ className }: QuickActionsBarProps) {
  const { t } = useTranslation('tips');

  return (
    <div className={cn('bg-white rounded-lg border border-gray-200 p-5', className)}>
      <h3 className="text-sm font-semibold text-gray-900 mb-4">
        {t('quickActions.title')}
      </h3>
      <div className="flex flex-wrap gap-3">
        {ACTIONS.map((action) => {
          const Icon = action.icon;
          return (
            <Link key={action.path} href={action.path}>
              <Button variant="outline" size="sm" className="gap-2">
                <Icon className="h-4 w-4" />
                {t(action.labelKey)}
              </Button>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
